import PropTypes from 'prop-types';
import React from 'react';

import { contentfulViews } from '@glowforge/ui-common';

const { TextSection } = contentfulViews;

const PaypalConfirmation = props => (
  <div className='ReferralPaymentPage contentPage'>
    <TextSection
      {...props.paypalConfirmationPageContent}
      headerClass='h1'
      className='content' />
  </div>
);

PaypalConfirmation.propTypes = {
  paypalConfirmationPageContent: PropTypes.shape(TextSection.propTypes).isRequired,
};

export default PaypalConfirmation;



// WEBPACK FOOTER //
// ./app/components/support/referral/paypal-confirmation.jsx